module.exports = __webpack_public_path__ + "img/cardPics.ff56f134.png";